var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 42.857 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.143 21.429V8.57l11.134 6.43ZM41.96 4.685a5.37 5.37 0 0 0-3.788-3.79C34.83 0 21.428 0 21.428 0S8.027 0 4.684.896A5.37 5.37 0 0 0 .895 4.685C0 8.027 0 15 0 15s0 6.973.895 10.316a5.37 5.37 0 0 0 3.79 3.788C8.026 30 21.427 30 21.427 30s13.402 0 16.744-.896a5.37 5.37 0 0 0 3.79-3.788c.895-3.343.895-10.316.895-10.316s0-6.973-.896-10.315"
})));
export default SvgYoutube;